export const BEGELEIDER = 'Begeleider';
export const PRAKTIJK = 'Praktijk';

export const REGISTRATION_TYPES = [BEGELEIDER, PRAKTIJK];
